import React from 'react';
import useTransportCompanyLogo from '../../../hooks/useTransportCompanyLogo';
import { TRANSPORT_COMPANY_LOGO_FORMATS } from '../../../constants/transportCompanyLogo';
import { LogoFallback, LogoImage } from './styles';

export default function TransportCompanyLogo({
    format = TRANSPORT_COMPANY_LOGO_FORMATS.SVG,
    alt = 'Logo da transportadora',
    fallback = 'Logo',
    className,
}) {
    const { url, missing, loading } = useTransportCompanyLogo(format);

    if (loading || missing || !url) {
        return (
            <LogoFallback className={className} aria-hidden={loading || undefined}>
                {fallback}
            </LogoFallback>
        );
    }

    return <LogoImage className={className} src={url} alt={alt} />;
}

export { ProfileLogoFrame, ProfileLogoWrap } from './styles';
